import { db } from '../db';
import { recordPetalFallDate } from './phenologyService';

/**
 * Save a petal fall date recording to IndexedDB for offline persistence.
 * The record is stored as 'pending' and will be uploaded by the sync engine.
 */
export const savePetalFallLocally = async (
  orchardId: string,
  date: string
): Promise<number | undefined> => {
  return db.phenologyRecords.add({
    orchardId,
    date,
    syncStatus: 'pending',
    createdAt: new Date().toISOString(),
  });
};

/**
 * Upload all pending phenology records to the backend.
 * Called by the sync engine on online events and heartbeat intervals.
 */
export const syncPendingPhenologyRecords = async (): Promise<void> => {
  const pending = await db.phenologyRecords
    .where('syncStatus')
    .anyOf(['pending', 'failed'])
    .toArray();

  if (pending.length === 0) return;

  console.log(`[PhenologySync] Syncing ${pending.length} pending phenology records...`);

  for (const record of pending) {
    try {
      await db.phenologyRecords.update(record.id!, { syncStatus: 'syncing' });

      await recordPetalFallDate(record.orchardId, record.date);

      await db.phenologyRecords.update(record.id!, { syncStatus: 'synced' });
      console.log(`[PhenologySync] Synced phenology record ${record.id}`);
    } catch (err) {
      console.error(`[PhenologySync] Failed to sync record ${record.id}:`, err);
      await db.phenologyRecords.update(record.id!, { syncStatus: 'failed' });
    }
  }
};
